/* eslint-disable no-fallthrough */
/* eslint-disable no-undef */
/* eslint-disable eqeqeq */
/* eslint-disable no-dupe-keys */
// eslint-disable-next-line import/no-duplicates
import serviceProvider from "../../services/provider/ProviderService";
import serviceDocument from "../../services/patient/DocumentService";
import PatientService from "../../services/patient/PatientService";
import i18n from "../../i18n/index";
import { StorageService } from "../../services/StorageService";
// eslint-disable-next-line import/no-duplicates
import serviceCalendar from "../../services/calendar/serviceCalendar";
import dayjs from "dayjs";
import AppointmentService from "../../services/appointment/ServiceAppointment";
import appointmentList from "./appointmentList/appointmentList.vue";

export default {
    components: {
        appointmentList
    },
    data: () => ({
        disableOptions: ["isWatched", "isApplicable"],
        showGrid: false,
        panel: [],
        dialog: false,
        menuDelivery: false,
        providers: [],
        observation: "",
        date: new Date().toISOString().substr(0, 10),
        attachment: { name: "" },
        createReminder: false,
        showProvider: false,
        patientListData: [],
        disableSaveButton: false,
        showProviderColumn: false,
        menu: false,

        rules: { required: value => !!value || "El campo es requerido" },
        states: [],
        cities: [],
        branches: [],
        documentTypeItems: [],
        orderPatient: [],
        orderTypeItems: ["EXCLUSIVO", "INTEGRADO"],
        itemTypeOrder: [{
                id: "EXCLUSIVE",
                name: "Exclusivo"
            },
            {
                id: "INTEGRATED",
                name: "Integrado"
            }
        ],
        scheduleRanges: [],

        location: {
            state: "",
            city: "",
            branch: "",
            scheduleRange: ""
        },

        patient: {
            id: "",
            type: "",
            document: "",
            fullname: "",
            address: "",
            cellPhoneNumber: "",
            phoneNumber: ""
        },

        order: {
            status: "",
            number: "",
            deliveryAddress: "",
            orderType: "",
            deliveryDate: "",
            notApplyShippingFee: false
        },
        bin: [],
        vademecumData: [],
        fechaAllowed: "",
        idBranch: "",
        branchesObj: "",
        city: null,
        addressBranch: "",
        enabledDays: [],
        scheduleRangeData: [],
        idBranchAux: "",
        idScheduleRange: "",
        attentionHours: "",
        dialog: false,
        idOrderAppointment: "",
        theIdAppointment: "",

        attendedCheck: false,
        buttonDisabled: false
    }),
    created() {
        this.order.orderType = this.itemTypeOrder[0].id;
        this.activeProvider();
    },

    mounted() {
        this.getDocumentTypes();
        this.getStates();
    },

    methods: {
        activeProvider() {
            let user = JSON.parse(localStorage.getItem("user"));
            let providerId = user.providerId;

            if (providerId === 1) {
                this.showProvider = true;
            }

            if (providerId !== 1) {
                this.showProviderColumn = false;
                // this.headers.splice(6, 1)
            }
        },
        disableButton() {
            if (
                this.patient.type == "" ||
                this.patient.document == "" ||
                this.patient.fullname == "" ||
                this.location.state == "" ||
                this.location.city == "" ||
                this.location.branch == "" ||
                this.order.deliveryDate == "" ||
                this.location.scheduleRange == ""
            ) {
                return (this.buttonDisabled = true);
            }
        },
        async saveScheduling() {
            if (this.attendedCheck == true) {
                this.attended();
            }
            let noMobilePhone = false
            this.patientListData.forEach(p => {
              if (p.mobilePhone === '' || p.mobilePhone === null || p.mobilePhone === undefined) {
                noMobilePhone = true
              }
            })
            if (noMobilePhone) {
              this.$notify({
                group: "app",
                type: "error",
                text: "El celular es un campo requerido, por favor registrar para continuar"
              })
              return
            }
      
            let noPhone = false
            this.patientListData.forEach(p => {
              if (p.phone === '' || p.phone === null || p.phone === undefined) {
                noPhone = true
              }
            })
            if (noPhone) {
              this.$notify({
                group: "app",
                type: "error",
                text: "El telefono es un campo requerido, por favor registrar para continuar"
              });
              return
            }
            if (JSON.stringify(this.patient) === "{}") {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t("app.scheduling.error-no-patients")
                });
                return;
            }
            this.order.status = "SCHEDULED";
            let formData = {
                patients: [{
                    documentType: this.patient.type,
                    document: this.patient.document,
                    fullname: this.patient.fullname,
                    address: this.patient.address,
                    phoneNumber: this.patient.cellPhoneNumber,
                    mobilePhone: this.patient.phoneNumber
                }],
                orderData: {
                    status: "SCHEDULED",
                    AppointmentDate: this.order.deliveryDate,
                    idAppointment: this.theIdAppointment
                },
                RankOfTime: {
                    id: this.location.scheduleRange,
                    attentionHours: this.idScheduleRange.attentionHours
                },
                note: this.notes,
                observation: this.observation,
                userId: StorageService.getUserData().id
            };
            this.disableSaveButton = true;
            console.log(formData)
            const response = await AppointmentService.saveSchedulingAppointment(
                formData
            );
            if (response.data.error) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "Ha ocurrido un error al agendar el pedido"
                });
            }

            this.closeOrder();
        },

        prefijo(num) {
            return num < 10 ? "0" + num : num;
        },
        newDate(partes) {
            let date = new Date(0);
            date.setHours(partes[0]);
            date.setMinutes(partes[1]);
            return date;
        },
        getAllowedDate() {
            let data = {
                date: new Date().toISOString("YYYY-MM-DD").substr(0, 10),
                provider: StorageService.getUserData().providerId
            };

            let val = new Date().toISOString("YYYY-MM-DD").substr(0, 10);
            let theDate = dayjs(val);

            serviceCalendar
                .getAllowedDate(data)
                .then(result => {
                    if (result.data.code.length === 0) {
                        let sumDate = this.sumDateWeekend(theDate.format("YYYY/MM/DD"));
                        serviceCalendar
                            .getAllowedDate({
                                date: sumDate.format("YYYY-MM-DD"),
                                provider: StorageService.getUserData().providerId
                            })
                            .then(result => {
                                for (let i = 0; i < result.data.code.length; i++) {
                                    this.fechaAllowed = sumDate.add(
                                        parseInt(result.data.code[i].daysAnswer),
                                        "day"
                                    );
                                    this.fechaAllowed = this.fechaAllowed.format("YYYY-MM-DD");
                                    console.log("Fecha Minima: ", this.fechaAllowed);
                                    this.order.deliveryDate = this.fechaAllowed;
                                }
                            })
                            .catch(erro => {
                                console.log(erro);
                            });
                    } else {
                        for (let i = 0; i < result.data.code.length; i++) {
                            let otherFech = result.data.code[i].Date;
                            if (otherFech === val) {
                                let dateDesde = this.newDate(
                                    new Date()
                                    .toString()
                                    .substring(16, 24)
                                    .split(":")
                                );
                                let dateHasta = this.newDate(
                                    result.data.code[0].closingDate.split(":")
                                );

                                let minutos = (dateHasta - dateDesde) / 1000 / 60;
                                let horas = Math.floor(minutos / 60);
                                minutos = minutos % 60;
                                let total =
                                    this.prefijo(parseInt(horas)) +
                                    ":" +
                                    this.prefijo(parseInt(minutos));
                                let validNumber = this.validarNumber(total);
                                if (validNumber) {
                                    theDate = dayjs(otherFech).add(1, "day");
                                    let newFech = this.callDate(
                                        theDate.format("YYYY/MM/DD"),
                                        StorageService.getUserData().idBranch
                                    );
                                    if (newFech.code === undefined) {
                                        let sumDate = this.sumDateWeekend(
                                            theDate.format("YYYY-MM-DD")
                                        );
                                        this.fechaAllowed = sumDate.format("YYYY-MM-DD");
                                        // this.order.deliveryDate = this.fechaAllowed
                                    } else {
                                        this.fechaAllowed = theDate.format("YYYY-MM-DD");
                                        // this.order.deliveryDate = this.fechaAllowed
                                    }
                                } else {
                                    theDate = theDate.add(
                                        parseInt(result.data.code[i].daysAnswer),
                                        "day"
                                    );
                                    let newFech = this.callDate(
                                        theDate.format("YYYY/MM/DD"),
                                        StorageService.getUserData().idBranch
                                    );
                                    if (newFech.code === undefined) {
                                        let sumDate = this.sumDateWeekend(
                                            theDate.format("YYYY/MM/DD")
                                        );
                                        this.fechaAllowed = sumDate.format("YYYY-MM-DD");
                                        // this.order.deliveryDate = this.fechaAllowed
                                    } else {
                                        this.fechaAllowed = theDate.format("YYYY-MM-DD");
                                        // this.order.deliveryDate = this.fechaAllowed
                                    }
                                }
                            } else {
                                // Sabado
                                if (dayjs(theDate).day() === 6) {
                                    this.fechaAllowed = theDate.add(2, "day");
                                    this.fechaAllowed = this.fechaAllowed.format("YYYY-MM-DD");
                                    // this.order.deliveryDate = this.fechaAllowed
                                }
                                // Domingo
                                if (dayjs(theDate).day() === 0) {
                                    this.fechaAllowed = theDate.add(1, "day");
                                    this.fechaAllowed = this.fechaAllowed.format("YYYY-MM-DD");
                                    // this.order.deliveryDate = this.fechaAllowed
                                }
                            }
                        }
                    }
                    data = {};
                })
                .catch(erro => {
                    console.log(erro);
                });
        },

        sumDateWeekend(date) {
            let sum = dayjs(date);
            switch (sum.day()) {
                case 6: // Sabado
                    sum = sum.add(1, "day");
                case 0: // Domingo
                    sum = sum.add(1, "day");
                default:
                    // eslint-disable-next-line no-self-assign
                    sum = sum;
            }
            return sum;
        },
        validarNumber(number) {
            return number.includes("-");
        },
        callDate(date, id) {
            let data = {
                date: date,
                provider: id
            };
            let response = [];

            serviceCalendar
                .getAllowedDate(data)
                .then(result => {
                    response.push(result.data);
                })
                .catch(erro => {
                    console.log("Error: ", erro);
                });

            return response;
        },
        closeOrder() {
            this.patient = {
                id: "",
                type: "",
                document: "",
                fullname: "",
                cellPhoneNumber: "",
                phoneNumber: ""
            };
            this.location = {
                state: "",
                city: "",
                branch: "",
                scheduleRange: ""
            };
            this.addressBranch = "";
            this.attentionHours = "";
            this.showGrid = false;
        },

        contains(arr, id) {
            return arr.some(e => e.id === id);
        },

        showNoCoverageForAnyCity(type) {
            this.$notify({
                group: "app",
                type,
                text: i18n.t("app.scheduling.no-coverage-area")
            });
        },
        filterKeyCount(e) {
            const key = e.key;
            if (/[0-9]/.test(key)) {} else {
                return e.preventDefault();
            }
        },

        filterKey(e) {
            const key = e.key;
            if (/[0-9--]/.test(key)) {} else {
                return e.preventDefault();
            }
        },
        filterKeyletters(e) {
            const key = e.key;
            if (/[A-Za-z- ]/.test(key)) {} else {
                return e.preventDefault();
            }
        },

        showError(text) {
            this.$notify({
                group: "app",
                type: "error",
                text
            });
        },

        customFilter(item, queryText, itemText) {
            const textOne = item.description.toLowerCase();
            const textTwo = item.plu.toLowerCase();
            const searchText = queryText.toLowerCase();

            return (
                textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
            );
        },

        getDocumentTypes() {
            serviceDocument.getDocuments().then(response => {
                this.documentTypeItems = response.data;
            });
        },

        async searchPatient() {
            if (!this.patient.type) {
                this.showError(i18n.t("no-options-selected-for-document-type"));
                return;
            }

            if (!this.patient.document) {
                this.showError(i18n.t("no-patient-id"));
                return;
            }

            await PatientService.getByDocument(
                this.patient.type,
                this.patient.document
            ).then(response => {
                if (response && response.data && response.data.id) {
                    const data = response.data;
                    this.patient.id = data.id;
                    this.patient.fullname = data.name;
                    this.patient.address = data.address;
                    this.patient.cellPhoneNumber = data.mobilePhone;
                    this.patient.phoneNumber = data.phone;
                    this.getAllowedDate();
                } else {
                    this.showError(i18n.t("patient-not-exist"));
                }
            });
        },

        deleteTableRow(item) {
            if (patientInarray === undefined) {
                const auxPatient = this.patientListData.find(patient => {
                    return patient.document === item.document;
                });
                const index = this.patientListData.indexOf(auxPatient);
                this.patientListData.splice(index, 1);
            }
        },

        addItem() {
            if (this.patient.document === "") {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t("app.scheduling.no-document")
                });
                return;
            }

            if (this.patient.type === "") {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t("app.scheduling.no-document-type")
                });
                return;
            }

            if (this.patient.fullname === "") {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t("app.scheduling.no-name")
                });
                return;
            }

            const auxPatient = {
                id: this.patient.id,
                document: this.patient.document,
                documentType: this.patient.type,
                fullname: this.patient.fullname,
                address: this.patient.address,
                cellPhoneNumber: this.patient.cellPhoneNumber,
                phoneNumber: this.patient.phoneNumber
            };
            const document = this.patientListData.find(patient => {
                return patient.document === auxPatient.document;
            });
            if (document === undefined) {
                this.patientListData.push(auxPatient);
            }
        },
        async getStates() {
            try {
                const response = await AppointmentService.statesAppointment();
                this.states = response.data;
            } catch (error) {}
        },
        async getCities() {
            try {
                this.cityIsLoading = true;
                const result = await AppointmentService.cityAppointment(this.state);
                this.cities = result.data;

                this.cityIsLoading = false;
            } catch (error) {
                this.cityIsLoading = false;
            }
        },

        async branchesAppointment() {
            let branch = [];
            const response = await AppointmentService.getBranchesAppointment(
                this.location.city
            );
            const branches = response.data;
                console.log(branches)
            branches.forEach(branche => {
                branche.idDeliveryPoint.idBranch = branche.id;
                branch.push(branche.idDeliveryPoint);
            });
            this.idBranches = branch;
            this.branches = branch.map(namePharmacys => {
                return {
                    name: namePharmacys.name,
                    id: namePharmacys.id,
                    address: namePharmacys.address
                };
            });
        },
        getAddress() {
            let aux = this.branches.find(branch => branch.id == this.location.branch);
            this.addressBranch = aux.address ? aux.address : "";
            this.getDayAttentionByBranch();
        },
        async getDayAttentionByBranch() {
            this.idBranchAux = this.idBranches.find(
                branch => branch.id == this.location.branch
            );
            this.idBranch = this.idBranchAux.idBranch;
            const response = await AppointmentService.getDayAttentionByBranch(
                this.idBranch
            );
            let data = response.data;
            for (let i = 0; i < data.length; i++) {
                this.enabledDays.push(
                    new Date(data[i].idCapacity.Day).toISOString().substr(0, 10)
                );
            }
            this.getAllowedDates();
            this.menu = false;
        },
        getAllowedDates(val) {
            for (let i = 0; i < this.enabledDays.length; i++) {
                if (this.enabledDays[i] == val) {
                    return val;
                }
            }
        },

        async getScheduleRanges() {
            const response = await AppointmentService.getCalendarAppointment(
                this.idBranch,
                this.order.deliveryDate
            );
            this.scheduleRangeData = response.data;
            console.log(this.scheduleRangeData);

            this.scheduleRangeData.map(dataScheduled => {
                dataScheduled.idScheduleRangeAppointment.idCapacity.map(capacity =>
                    capacity.idAppointment.map(
                        appointment => (this.theIdAppointment = appointment.id)
                    )
                );
            });
            console.log(this.theIdAppointment);
        },
        getNameAttentionHours() {
            this.idScheduleRange = this.scheduleRangeData.find(
                schedule => schedule.id == this.location.scheduleRange
            );
            console.log(this.idScheduleRange);

            this.attentionHours = this.idScheduleRange.attentionHours ?
                this.idScheduleRange.attentionHours :
                "";
        },

        showArea() {
            showTextArea = true;
        },
        async cancelApointment() {
            if (this.idOrderAppointment == "" || this.idOrderAppointment == null) {
                this.dialog = false;
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "Esta cita aún no ha sido agendada."
                });
                this.closeOrder();
                return;
            }
            if (this.order.status == "DELIVERED" || this.order.status == "Asistio") {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "Ya se asistio a esta cita."
                });
                this.dialog = false;
                this.closeOrder();
                return;
            }
            this.order.status = "CANCELED";
            const status = {
                status: this.order.status
            };

            await AppointmentService.cancelAppointment(
                this.idOrderAppointment,
                status
            ).then(response => {
                this.$notify({
                    group: "app",
                    type: "success",
                    text: "Cita cancelada con Éxito."
                });
                this.closeOrder();
                this.dialog = false;
            });
        },
        async attended() {
            if (this.order.status == "CANCELED" || this.order.status == "Cancelado") {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "Esta cita ya fue cancelada."
                });
                this.closeOrder();
                this.dialog = false;
                return;
            }

            this.order.status = "DELIVERED";

            const status = {
                status: this.order.status
            };
            await AppointmentService.attended(this.idOrderAppointment, status).then(
                response => {
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: "El usuario asistio a la cita."
                    });
                    this.closeOrder();
                    this.dialog = false;
                }
            );
            return;
        },

        async handleOrder(order) {
            console.log(order
            );
            this.showGrid = !this.showGrid;
            const patient = order.idPatient;
            // const dataAppointment = order

            this.idOrderAppointment = order.id;

            this.patient.id = patient.id;
            this.patient.type = patient.idIdentificationType.id;
            this.patient.document = patient.identification;
            this.patient.fullname = patient.name;
            this.patient.cellPhoneNumber = patient.mobilePhone;
            this.patient.phoneNumber = patient.phone;

            await this.getCities();

            this.order.deliveryDate = order.idAppointment.idCapacity.Day;

            this.location.state =
                order.idAppointment.AppointmentDetails[0].idBranch.branchCities[0].idCity.idState.id;
            this.location.city =
                order.idAppointment.AppointmentDetails[0].idBranch.branchCities[0].idCity.id;
            this.location.branch =
                order.idAppointment.AppointmentDetails[0].idBranch.idDeliveryPoint.id;
            this.idBranch = order.idAppointment.AppointmentDetails[0].idBranch.id;
            this.addressBranch =
                order.idAppointment.AppointmentDetails[0].idBranch.idDeliveryPoint.address;
            this.order.status = order.status;
            if (order.status == "DELIVERED" || order.status == "Asistio") {
                this.attendedCheck = true;
            }
            await this.branchesAppointment();

            await this.getScheduleRanges();

            this.location.scheduleRange =
                order.idAppointment.idCapacity.idScheduleRangeAppointment.rankOfTime.id;
        },
        validateNumberCellphone() {
            if (this.patient.cellPhoneNumber[0] == '' || this.patient.cellPhoneNumber[0] == undefined) {
              return
            }
            if (this.patient.cellPhoneNumber[0] != '3') {
              this.$notify({
                group: "app",
                type: "error",
                text: "El número celular debe empezar con el número 3."
              })
            }
            if (this.patient.cellPhoneNumber.length == 10) {
              this.buttonDisabled = true;
              let count = 0;
              for (let i = 0; i < this.patient.cellPhoneNumber.length; i++) {
                let numberInitial = this.patient.cellPhoneNumber[0]
      
                if (numberInitial == this.patient.cellPhoneNumber[i]) {
                  count += 1;
                }
              }
              if (count >= 7) {
                this.buttonDisabled = false;
                this.$notify({
                 group: "app",
                 type: "error",
                 text: "Número inválido."
                })
              }
            }
          },
          validateNumberphone() {
            if (this.patient.phoneNumber[0] == '' || this.patient.phoneNumber[0] == undefined) {
              return
            }
            if (this.patient.phoneNumber.length >= 7) {
              this.buttonDisabled = true;
              let count = 0;
              for (let i = 0; i < this.patient.phoneNumber.length; i++) {
                let numberInitial = this.patient.phoneNumber[0]
      
                if (numberInitial == this.patient.phoneNumber[i]) {
                  count += 1;
                }
              }
              if (count >= 7) {
                this.buttonDisabled = false;
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "Número inválido."
                })
              }
            }
          }        
    },
    watch: {
        city() {
            this.getCities();
            this.branchesAppointment();
        },
        cellPhoneNumber() {
            this.validateNumberCellphone()
          },
        phoneNumber() {
            this.validateNumberphone()
          },
    },
    computed: {
        phoneNumber() {
            return this.patient.phoneNumber;
        },
        cellPhoneNumber(){
            return this.patient.cellPhoneNumber;
        },
        notes: {
            get() {
                return (
                    `Su cita queda programada para el día ${this.order.deliveryDate},` +
                    `en el horario ${this.attentionHours} ` +
                    `en el punto de entrega ${this.idBranchAux.name}. ` +
                    "Recuerde presentarse con documento original o copia del mismo y el valor efectivo para el pago. " +
                    "¡Que tenga un feliz día!"
                );
            },
            set(notes) {
                this.notes = notes;
            }
        }
    }
};